import React, {useEffect, useRef} from "react";
import styles from "./Modal.module.scss";
import {ModalPropsInterface} from "./Modal.props.interface";

const Modal: React.FC<ModalPropsInterface> = (
    {
        active = false,
        onActive,
        children = undefined,
        className = undefined,
        style = {},
        onEscape,
        onMissClick,
        ...rest
    }) => {

    const backgroundRef = useRef<HTMLDivElement | null>(null)
    const containerRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        handleAutofocus()
    }, [active]);

    const handleAutofocus = () => {
        active && containerRef?.current && setTimeout(() => containerRef.current!.focus(), 150)
    }

    const handleMissClick = (e: any) => {
        if (!(onMissClick && e && e.target && backgroundRef.current && e.target.contains(backgroundRef.current))) return

        onMissClick(e)
        onActive(false)
    };

    const handleEscape = (e: any) => {
        if (!(e.key === 'Escape' && active)) return

        onEscape(e)
        onActive(false)
    };

    return (
        <>
            <div
                className={[styles.background, active ? styles.isActive : null].filter(x => x).join(' ')}
                ref={backgroundRef}
                tabIndex={0}
                onKeyDown={handleEscape}
                onClick={handleMissClick}
                {...rest}
            >
                <div
                    className={[styles.container, className].filter(x => x).join(' ')}
                    tabIndex={0}
                    style={style}
                    ref={containerRef}>
                    {children}
                </div>
            </div>
        </>
    );
};

export default Modal;
